import * as React from "react";
import _ from "lodash";
import { FocusForm } from "../form/FocusForm";
import { Classes } from "@focus/focusUI";
import { getUnconditionalSchema } from "../utils/validation";
export class Separator extends React.PureComponent {
    render() {
        const { uiSchema, formData, errors } = this.props;
        const _schema = getUnconditionalSchema(this.props.schema, formData);
        const isReadOnly = typeof uiSchema["ui:readOnly"] !== "undefined" && uiSchema["ui:readOnly"]
            ? true
            : false;
        const isHidden = typeof uiSchema["ui:hidden"] !== "undefined" && !!uiSchema["ui:hidden"];
        const newUi = _.cloneDeep(this.props.uiSchema);
        delete newUi["ui:field"];
        const handleChange = (newData, change) => {
            this.props.onChange(newData, change);
        };
        const newErrors = errors ? errors : {};
        if (isHidden) {
            return null;
        }
        else {
            return (React.createElement("div", null,
                React.createElement("div", { className: "centered-separator" },
                    React.createElement("label", { className: Classes.LABEL },
                        React.createElement("b", null, _schema.title),
                        "\u00A0\u00A0")),
                React.createElement(FocusForm, { schema: _schema, uiSchema: newUi, formData: formData, readOnly: isReadOnly, errors: newErrors, onChange: handleChange, ommitDisabledCheck: true }),
                React.createElement("hr", { className: "fw-form-break" })));
        }
    }
}
//# sourceMappingURL=Separator.js.map